// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
// -- Helpers END

windowLoad(function() {
	$(".preview-test__btn").on("click", function(e) {
		e.preventDefault()
		$('.test__data').addClass("test__data--hidden")
		$('.test-questions').removeClass("test-questions--hidden")
	});
});
